'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getChatHeadingResponders = undefined;

var _reselect = require('reselect');

var _chatHeadingRespondersList = require('../operators/chatHeadingRespondersList');

var _getChatHeadingConfig = require('../../chat-heading-config/selectors/getChatHeadingConfig');

var _getAgentRespondersList = require('./getAgentRespondersList');

var _getAssignedResponderInWidget = require('./getAssignedResponderInWidget');

var _getSendFromResponders = require('./getSendFromResponders');

var getChatHeadingResponders = exports.getChatHeadingResponders = (0, _reselect.createSelector)([_getAssignedResponderInWidget.getAssignedResponderInWidget, _getChatHeadingConfig.getChatHeadingConfig, _getAgentRespondersList.getAgentRespondersList, _getSendFromResponders.getSendFromResponders], function (assignedResponder, chatHeadingConfig, responders, sendFromResponders) {
  return (0, _chatHeadingRespondersList.chatHeadingRespondersList)({
    assignedResponder: assignedResponder,
    chatHeadingConfig: chatHeadingConfig,
    responders: responders,
    sendFromResponders: sendFromResponders
  });
});


//////////////////
// WEBPACK FOOTER
// ./js/responders/selectors/getChatHeadingResponders.js
// module id = 352
// module chunks = 2 3